import { createAction } from "redux-starter-kit";

import {
  FETCH_FREEZEEXEMPT_FAILURE,
  FETCH_FREEZEEXEMPT_REQUEST,
  FETCH_FREEZEEXEMPT_SUCCESS
} from "../types";

const fetchFreezeExemptContractTypes = factoringId => async (
  dispatch,
  getState,
  { api }
) => {
  try {
    dispatch(createAction(FETCH_FREEZEEXEMPT_REQUEST)());
    const response = await api.factoring.getFreezeExemptContractTypes(
      factoringId
    );
    dispatch(
      createAction(FETCH_FREEZEEXEMPT_SUCCESS)({
        factoringId,
        contractTypes: response.map(row => row.contract_type)
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(FETCH_FREEZEEXEMPT_FAILURE)(err));
    throw err;
  }
};

export default fetchFreezeExemptContractTypes;
